/* eslint-disable @typescript-eslint/no-require-imports */
export const menuListe = [
    {
      title: 'Catalogue de produit',
      source: require('../../ressources/images/ic_catalogue_64.png'),
    },
    {
      title: 'Lexique',
      source: require('../../ressources/images/ic_lexique_64.png'),
    },
    {
      title: 'Les démarches',
      source: require('../../ressources/images/ic_demarche_64.png'),
    },
    {
      title: 'Demander simulation',
      source: require('../../ressources/images/ic_sumilation_64.png'),
    },
    {
      title: 'Nous contacter',
      source: require('../../ressources/images/ic_event_64.png'),
    },
    {
      title: 'FAQ',
      source: require('../../ressources/images/ic_contact_64.png'),
    },
  ];
  